// extracted by mini-css-extract-plugin
module.exports = {"lds-roller":"style_lds-roller__aZ_3P","div-after":"style_div-after__2_oFv"};